import { useQuery, QueryConfig, useMutation, MutateConfig, queryCache } from "react-query";
import siteConfig from "site-config";
import { fetchJSON } from "lib/fetch";

const SITES_MENU = "sites_menu";

export enum MenuSitesKeys {
    DigitalTradeShow = "digitalTradeShow",
    DigitalFashionShow = "digitalFashionShow",
}

export interface IMenuSite {
    _id: string;
    key: string;
    sections: ISection[];
}

export interface ISection {
    name: string;
    slug?: string;
    depth?: number;
}

export const useFetchSitesMenu = (options?: QueryConfig<IMenuSite[]>) => {
    return useQuery<IMenuSite[], string>(
        SITES_MENU,
        () =>
            fetchJSON<IMenuSite[]>(`${siteConfig.api}/sites/menu`, {
                method: "GET",
                noDomain: true,
            }),
        {
            ...options,
            refetchOnWindowFocus: false,
        },
    );
};

export const useUpdateSiteMenuById = (mutationObject?: MutateConfig<IMenuSite, Error[]>) => {
    return useMutation(updateSiteMenuById, {
        ...mutationObject,
        onSuccess: (data: IMenuSite) => {
            queryCache.invalidateQueries(SITES_MENU);
            mutationObject?.onSuccess?.(data, {});
        },
        onError: (error, variables: ISection[], snap) => {
            queryCache.invalidateQueries(SITES_MENU);
            mutationObject?.onError?.(error, variables, snap);
        },
    });
};

function updateSiteMenuById(data: { _id: string; sections: ISection[] }) {
    return fetchJSON<IMenuSite>(`${siteConfig.api}/sites/menu/${data._id}`, {
        method: "POST",
        noDomain: true,
        body: JSON.stringify(data.sections),
    });
}
